module.exports = __webpack_public_path__ + "img/downArrowLQS.55d605e3.svg";